import { SelectItem } from 'components/shared/form/rhf_input';
import { BaseEntity } from 'entities';

/**
 * 部屋
 */
export type SubscriptionPlan = BaseEntity & {
  laboratoryId?: number;
  name?: string;
  limitCount?: number;
};

export type SubscriptionPlanForm = {
  name?: string;
  limitCount?: string;
};
// TODO: 編集フォームを実装する際は entities/instrument.ts のコメントと実装を参考に、同様の構造で実装する

export type SubscriptionName = 'free' | 'mini' | 'standard' | 'standard_extension' | 'volume';

export const subscriptionNameItems: SelectItem[] = [
  { value: 'free', label: 'フリー' },
  { value: 'mini', label: 'ミニ' },
  { value: 'standard', label: 'スタンダード' },
  { value: 'standard_extension', label: 'スタンダード拡張' },
  { value: 'volume', label: 'ボリューム' },
];

// プラン毎の機器数のデフォルト値
export const subscriptionLimitCount: { [key: string]: string } = {
  free: '20',
  mini: '20',
  standard: '100',
  standard_extension: '100',
  volume: '', // 無制限
};
